import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { brandUrl } from "../../../util/url";
import { openAppAndAction } from "../../../util/util";
import { useAppInstallModal } from "../../../store/useAppInstallModal";
import IconHeartOutline from "../../../component/productsList/assets/heartIcon.svg";
import CircleLetterLogo from "../../../component/circleLetterLogo/CircleLetterLogo";

export default function BrandRankingItem({ rank, brand, isLast}) {
  const { openModal } = useAppInstallModal();
  const handleOnClickPopup = () => {
    openAppAndAction(() => openModal("앱에서 더 많은\n상품을 비교해보세요!"), null, 1000);
  };

  return (
    <li className={`BrandRankingItem ${isLast ? "last" : ""}`}>
      <div className="BrandRankingItem-rank">{rank}</div>
      <Link to={brandUrl(brand.name)} className="BrandRankingItem-info">
        <div className="BrandRankingItem-logo">
          <CircleLetterLogo
              logo={brand.resizedSmallLogo}
              name={brand.name}
              size={44}
          />
        </div>
        <div className="BrandRankingItem-text">
          <div className="BrandRankingItem-name">{brand.name}</div>
          {brand.name_kr && (
            <div className="BrandRankingItem-name-kr">{brand.name_kr}</div>
          )}
        </div>
      </Link>
      <button type="button" className="BrandRankingItem-like" onClick={handleOnClickPopup}>
        <img src={IconHeartOutline} alt="like" className="BrandRankingItem-like-icon" />
      </button>
    </li>
  );
}

BrandRankingItem.propTypes = {
  rank: PropTypes.number.isRequired,
  brand: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    name: PropTypes.string.isRequired,
    name_kr: PropTypes.string,
    resizedSmallLogo: PropTypes.string,
  }).isRequired,
  isLast: PropTypes.bool,
};

BrandRankingItem.defaultProps = {
  isLast: false,
};
